import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Question, QuestionAnswer, QuestionGroupType } from 'src/app/interfaces/question';
import { QuestionService } from 'src/app/services/question/question.service';
/**
 * TODO: 현재는 케미의 피드백 코드 복붙. 호불호 월드컵에 맞춰 수정 필요
 */
@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent implements OnInit {
  @Input() type: QuestionGroupType | undefined;
  @Input() id: number | undefined;
  questionList: Question[][] = [[]];
  answerList: Map<number, QuestionAnswer> = new Map<number, QuestionAnswer>();
  page = 0;
  currentPageIndex = 0; // 현재 page의 list의 index

  constructor(
    private questionService: QuestionService
  ) { }
  
  ngOnInit() {
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('type') && changes.type.currentValue !== undefined) {
      this.questionService.feedbackQuestions(changes.type.currentValue).subscribe((res) => {
        this.questionList[this.page] = res.data ?? [];
      });
    }
  }

  /** 답변시, 이어지는 질문 있는 경우 해당 질문으로 대체 */
  questionAnswered(data: QuestionAnswer | undefined): void {
    // 답변 없이 그냥 '다음' 버튼 눌렀을 경우를 제외하고는 답변 전부 post
    if (data !== undefined && data.value) {
      this.postFeedbackAnswer(data);
    }
    
    // 아직 현재 questionGroup에 남은 질문이 있는 경우 해당 질문 진행.
    if (this.hasNextQuestionInQuestionGroup()) {
      this.currentPageIndex++;
      return;
    }

    if (data?.isNextQuestionGroupExists && data?.id !== undefined) {
      this.questionService.getNextQuestion(data.id).subscribe({
        next: (res) => {
          this.moveToNextQuestionGroup();
          this.setCurrentQuestionList(res.data);
          const scrollTimeout = setTimeout(() => {
            window.scrollTo(0, 2000);
            clearTimeout(scrollTimeout);
          })
        },
        error: (error) => {
          console.error('failed to getNextQuestion: ' + error);
          this.setCurrentQuestionList([]);
        }
      })
    } else {
      this.setCurrentQuestionList([]);
    }
  }

  /** 매 answer마다 post. 한 질문에 중복답변 시, update(from server) - insert or update */
  postFeedbackAnswer(answer: QuestionAnswer): void {
    if (this.id === undefined || this.type === undefined) {
      return;
    }
    this.questionService.postFeedback(this.id, [answer], this.type).subscribe({
      error: (error) => {
        console.error(error);
      }
    })
  }

  onClickBackward(): void {
    if (this.currentPageIndex > 0) {
      this.currentPageIndex--;
      return;
    }
    this.page = Math.max(0, this.page - 1);
  }

  private setCurrentQuestionList(data: Question[]): void{
    this.questionList[this.page] = data ?? [];
  }

  private moveToNextQuestionGroup(): void {
    this.page++;
    this.currentPageIndex = 0;
  }

  /** 현재 questionGroup에 남아있는 다음 질문이 있는 경우 */
  private hasNextQuestionInQuestionGroup(): boolean {
    return this.questionList[this.page].length > this.currentPageIndex + 1;
  }
}
